$component-class: 'stats-counter-card-type-3';

.#{$component-class} {
  padding: var(--spacing-2xl);
  background-color: var(--background-color-primary);
  border: var(--border-size-sm) solid var(--border-color-secondary);
  border-radius: var(--radius-size-lg);

  &__caption {
    font-family: $font-family-base;
    color: var(--text-color-primary);

    .me-heading {
      margin-bottom: var(--spacing-2xl);

      @include desktop {
        margin-bottom: var(--spacing-4xl);
      }
    }
  }

  &__counter {
    font-family: $font-family-base;
    color: var(--text-color-brand-primary);
    font-weight: map-get($font-weights, 'bold');
    font-size: 3.5rem;
    line-height: 130%;
    margin-bottom: var(--spacing-md);

    @include desktop {
      font-size: 5rem;
    }
  }

  &__description {
    font-family: $font-family-base;
    color: var(--text-color-primary);
    padding-top: var(--spacing-md);
    border-top: var(--border-size-sm) solid var(--border-color-secondary);
  }
}

@mixin generate-align-classes {
  @each $align in $aligns {
    .#{$component-class}--#{$align} {
      text-align: $align;
    }
  }
}

@include generate-align-classes;
